import type { Command } from "../types.ts";

const BAR_WIDTH = 16;

export const skills: Command = {
  name: "skills",
  aliases: ["stack"],
  description: "What I work with.",
  run(ctx) {
    const groups = ctx.term.profile.skillGroups;
    const nameWidth = Math.max(
      ...groups.flatMap((g) => g.skills.map((s) => s.name.length)),
    );

    for (const group of groups) {
      ctx.printHTML(`<span class="label">${e(group.label)}</span>`);
      for (const s of group.skills) {
        const filled = Math.round((s.level / 100) * BAR_WIDTH);
        const bar =
          `<span class="c-accent">${"█".repeat(filled)}</span>` +
          `<span class="c-dim">${"░".repeat(BAR_WIDTH - filled)}</span>`;
        const label = e(s.name).padEnd(nameWidth, " ").replace(/ /g, "&nbsp;");
        ctx.printHTML(`  ${label}  ${bar} <span class="c-muted">${s.level}%</span>`);
      }
      ctx.print("");
    }
  },
};

function e(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
